import { createVNode as n, mergeProps as o } from "vue";
import a from "../node_modules/@pf-ui/pf-icon-svg/es/asn/QuestionCircleOutlinedStandard.js";
import d from "../components/PfIcon.js";
const t = (r, e) => {
  const i = {
    ...r,
    ...e.attrs
  };
  return n(d, o(i, {
    icon: a
  }), null);
};
t.displayName = "QuestionCircleOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
